import Plyr from 'plyr';

(() => {
  const videoPlayers = document.querySelectorAll('.luna-video-player');

  const isVideoPlaying = video => {
    return !! (video.currentTime > 0 && ! video.paused && ! video.ended && video.readyState > 2);
  };

  const toggleVideo = (video, wrapper) => {
    if (isVideoPlaying(video)) {
      video.pause();
    } else {
      video.play();
    }
    wrapper.classList.toggle('is-playing');
  };

  const progressLoop = (video, progress) => {
    if (video.duration > 0) {
      progress.querySelector('.video-progress__value').style.transform = `scaleX(${ (video.currentTime / video.duration) })`;
    }
  };

  const bufferLoop = (video, buffer) => {
    if (video.duration > 0) {
      const bufferedEnd = video.buffered.end(video.buffered.length - 1);
      buffer.querySelector('.video-buffer__value').style.transform = `scaleX(${ (bufferedEnd / video.duration) })`;
    }
  };

  videoPlayers.forEach(element => {
    const videoPlayer = element.querySelector('.single-video-player');

    const isMuted = element.classList.contains('is-muted');
    const isAutoPlay = element.classList.contains('is-autoplay');
    const buffer = element.querySelector('.video-buffer');
    const progress = element.querySelector('.video-progress');
    const playButton = element.querySelector('.video-play-button');
    const playSmall = element.querySelector('.video-control__button--play');
    const volumeSmall = element.querySelector('.video-control__button--volume');
    const fullscreenSmall = element.querySelector('.video-control__button--fullscreen');

    element.classList[isAutoPlay ? 'add' : 'remove']('is-playing');

    if (videoPlayer) {
      let isPlaying = isAutoPlay;
      let plyrMuteState = isMuted;

      const plyr = new Plyr(videoPlayer, {
        controls: [],
        settings: [],
        loadSprite: false,
        autoplay: isAutoPlay,
        muted: isMuted,
        clickToPlay: false
      });

      if (playButton !== null) {
        playButton.addEventListener('click', () => {
          if (isPlaying) {
            plyr.pause();
            element.classList.remove('is-playing');
            element.classList.add('is-paused');
          } else {
            plyr.play();
            element.classList.add('is-playing');
            element.classList.remove('is-paused');
          }
          isPlaying = ! isPlaying;
        });
      }

      playSmall.addEventListener('click', () => {
        if (isPlaying) {
          plyr.pause();
          element.classList.remove('is-playing');
          element.classList.add('is-paused');
        } else {
          plyr.play();
          element.classList.add('is-playing');
          element.classList.remove('is-paused');
        }
        isPlaying = ! isPlaying;
      });

      volumeSmall.addEventListener('click', () => {
        plyrMuteState = ! plyrMuteState;
        plyr.muted = plyrMuteState;
        element.classList[plyrMuteState ? 'add' : 'remove']('is-muted');
      });

      plyr.on('ended', () => {
        element.classList.remove('is-waiting');
        element.classList.remove('is-playing');
        element.classList.remove('is-paused');
        isPlaying = false;
      });

      plyr.on('playing', () => {
        element.classList.add('is-playing');
        element.classList.remove('is-paused');
        isPlaying = true;
      });

      plyr.on('paused', () => {
        element.classList.remove('is-playing');
        element.classList.add('is-paused');
        isPlaying = false;
      });

      fullscreenSmall.addEventListener('click', () => {
        plyr.fullscreen.enter();
      });
    }

    const videoEl = element.querySelector('video');
    if (videoEl) {
      if (playButton !== null) {
        playButton.addEventListener('click', () => toggleVideo(videoEl, element));
      }

      playSmall.addEventListener('click', () => toggleVideo(videoEl, element));

      let muteState = isMuted;
      volumeSmall.addEventListener('click', () => {
        muteState = ! muteState;
        videoEl.muted = muteState;
        element.classList[muteState ? 'add' : 'remove']('is-muted');
      });

      videoEl.addEventListener('canplaythrough', () => {
        element.classList.add('can-play');
        videoEl.addEventListener('progress', () => bufferLoop(videoEl, buffer));
        videoEl.addEventListener('timeupdate', () => progressLoop(videoEl, progress));
        videoEl.addEventListener('waiting', () => element.classList.add('is-waiting'));
        videoEl.addEventListener('playing', () => element.classList.remove('is-waiting'));
        videoEl.addEventListener('pause', () => {
          element.classList.remove('is-playing');
          element.classList.add('is-paused');
        });
        videoEl.addEventListener('ended', () => {
          element.classList.remove('is-waiting');
          element.classList.remove('is-playing');
          element.classList.remove('is-paused');
          videoEl.currentTime = 0;
        });
      });

      fullscreenSmall.addEventListener('click', () => {
        if (videoEl.requestFullscreen) {
          videoEl.requestFullscreen();
        } else if (videoEl.webkitRequestFullscreen) {
          videoEl.webkitRequestFullscreen();
        } else if (videoEl.msRequestFullScreen) {
          videoEl.msRequestFullScreen();
        }
      });
    } else {
      element.classList.remove('is-playing');
    }
  });
})();
